export default __webpack_public_path__ + "static/media/patientBoy.8b815c80.svg";